import { HeaderBreadcrumb } from 'common/ui/Header';
import { Paths } from 'services/navigation/paths';
import { SourcingExternalStep } from '../stores/step-components/sourcingExternalStepComponents';

type GetSourcingExternalHeaderBreadcrumbsProps = {
  candidateBatchJobTitle: string;
  candidateBatchId: string;
  setStep: (step: SourcingExternalStep) => void;
};

// Breadcrumbs for the sourcing external header
// Analyse name -> Takes you to the analyse details page
// Source candidates -> Takes you to the search query step
// Invite to apply -> Takes you to the candidates list step
export const getSourcingExternalHeaderBreadcrumbs = ({
  candidateBatchJobTitle,
  candidateBatchId,
  setStep
}: GetSourcingExternalHeaderBreadcrumbsProps): HeaderBreadcrumb[] => {
  return [
    {
      name: candidateBatchJobTitle,
      path: `${Paths.ANALYSE}/${candidateBatchId}`
    },
    {
      name: 'Source candidates',
      action: () => {
        setStep('SEARCH');
      }
    },
    {
      name: 'Invite to apply',
      action: () => {
        setStep('SELECTED_CANDIDATES');
      }
    }
  ];
};
